/**
 * CUSTOM: Complementary products
 * Added: 2026-10-09
 * Description: Keeps the progress bar of blocks/custom-complementary-products.liquid
 * in step with Horizon's slideshow. The slideshow marks the slides in view with aria-hidden="false"
 * after every arrow click, swipe or scroll, so this only watches that attribute. The arrows themselves
 * are the slideshow's own previous/next refs.
 */
import { Component } from '@theme/component';

class CustomPairings extends Component {
  /** @type {MutationObserver | undefined} */
  #observer;

  connectedCallback() {
    super.connectedCallback();

    this.#observer = new MutationObserver(this.#update);
    for (const slide of this.#slides) {
      this.#observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
  }

  /** The carousel's own slides, not the image slides inside each card's gallery */
  get #slides() {
    return Array.from(this.querySelectorAll('slideshow-slide.resource-list__slide'));
  }

  #update = () => {
    const slides = this.#slides;
    const total = slides.length;
    const visible = slides
      .map((slide, index) => (slide.getAttribute('aria-hidden') === 'false' ? index : -1))
      .filter((index) => index > -1);

    if (!total || !visible.length) return;

    const end = visible[visible.length - 1] + 1;

    this.toggleAttribute('data-all-visible', visible.length >= total);
    this.style.setProperty('--custom-pairings-progress', `${(end / total) * 100}%`);
  };
}

if (!customElements.get('custom-pairings')) customElements.define('custom-pairings', CustomPairings);
